import type { VrsChatStatus } from 'features/vrs-chat/enums';

export enum VrsChatOpenedBy {
  Agent = 'agent',
  Message = 'message',
}

export type VrsChatOpenedByType = VrsChatOpenedBy | null;

export interface VrsChatState {
  isVisible: boolean;
  status: VrsChatStatus;
  isCollapsed: boolean;
  openedBy: VrsChatOpenedByType;
}
